import React, { createContext, useContext, useState, useEffect } from 'react';

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(() => {
    const storedAuth = localStorage.getItem('auth_tokens');
    return storedAuth ? JSON.parse(storedAuth) : null;
  });

  const login = (tokens) => {
    localStorage.setItem('auth_tokens', JSON.stringify(tokens));
    setAuth(tokens);
  };

  const logout = () => {
    localStorage.removeItem('auth_tokens');
    setAuth(null);
    window.location.href = '/authentiate';
  };

  return (
    <AuthContext.Provider value={{ 
      auth,
      login, 
      logout,
      isAuthenticated: !!auth,
      role: auth?.role || null
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};